{
  "instances": {
    "beans": {
      "label": "Beans",
      "name": "Name",
      "aliases": "Aliases",
      "type": "Type",
      "resource": "Resource",
      "dependencies": "Dependencies"
    }
  }
}
